import React from "react";
import styled from "styled-components";
import { Box, Flex } from "reflexbox/styled-components";
import { Button } from "antd";
import { strings } from "../../languages/Localize";
import { useHistory } from "react-router";

const StyledTitleContainer = styled(Flex)`
    left: 0;
    height: 7%;
    flex-direction: column;
    width: 100%;
    justify-content: space-between;
    border-bottom: 2px solid white;
`;

export const StyledSeparator = styled(Box)`
    width: 100%;
    border-bottom: 2px solid white;
`;

const StyledText = styled(Flex)`
    color: white;
    justify-content: space-between;
    align-items: center;
    height: 100%;
`;

const StyledHeaderButton = styled(Button)`
    && {
        display: flex;
        border-radius: 4px;
        color: ${({ theme }) => theme.colors.white};
        border-color: ${({ theme }) => theme.colors.white};
        background: transparent;
        text-align: center;
        margin-bottom: 4px;
    }
    &&:hover,
    &&:active {
        outline: none;
    }
`;

const TitleSeparator = props => {
    const history = useHistory();
    const backHandler = () => history.goBack();
    return (
        <StyledTitleContainer className={props.className}>
            <StyledText paddingX={[4, 5]} paddingBottom={2} fontWeight="semiBold" fontSize={[6]}>
                {props.children}
                {props.back && (
                    <StyledHeaderButton fontSize={[3, 4]} shape="round" onClick={backHandler}>
                        {strings.panel.BACK}
                    </StyledHeaderButton>
                )}
            </StyledText>
        </StyledTitleContainer>
    );
};

export default TitleSeparator;
